const creditCardBaseUrl = '/CreditCard';

export default {
    creditCardsUrl: () => `${creditCardBaseUrl}`,
    paymentStatusUrl: (transactionId) =>
        `${creditCardBaseUrl}/paymentStatus?CreditCardTransactionId=${transactionId}`,
    embeddedPaymentStatusUrl: (transactionId) =>
        `${creditCardBaseUrl}/embeddedStatus?CreditCardTransactionId=${transactionId}`,
};
